import axios from 'axios';
import { GET_ENCAISSEMENT_LINES, ADD_ENCAISSEMENT_LINE, DELETE_ENCAISSEMENT_LINE, CLEAR_ENCAISSEMENT_LINES } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IEncaissementLine } from '../../types/interfaces';

export const getEncaissementLines = () => (dispatch: Function) => {
  dispatch({
    type: GET_ENCAISSEMENT_LINES,
    payload: []
  })
};

export const addEncaissementLine = (encaissementline: IEncaissementLine) => (
  dispatch: Function
) => {
    dispatch({
      type: ADD_ENCAISSEMENT_LINE,
      payload: encaissementline
    });
};

export const deleteEncaissementLine = (id: number) => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: DELETE_ENCAISSEMENT_LINE,
    payload: id
  })
};

export const clearEncaissementLines = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_ENCAISSEMENT_LINES
  })
};
